<template>
  <div class="item-base">
    <div class="item-header">
      <span>公司介绍</span>
    </div>
    <user-detail-base style="height: 79vh;">
      <el-form label-position="left" label-width="100px" size="mini" class="company-item" v-if="Cdata">
        <el-form-item label="ID" >
          <pre>{{Cdata.id}}</pre>
        </el-form-item>
        <el-form-item label="公司名称" >
          <pre>{{Cdata.name}}</pre>
        </el-form-item>
        <el-form-item label="公司logo" >
          <el-image :src="'http://'+Cdata.logoUrl" class="item-image"></el-image>
        </el-form-item>
        <el-form-item label="短语" >
          <pre>{{Cdata.phrase}}</pre>
        </el-form-item>
        <el-form-item label="公司简介描述" >
          <p class="decription" v-html="Cdata.description"></p>
        </el-form-item>
        <el-form-item label="简介图片" >
          <el-image :src="'http://'+Cdata.introPhotoUrl" class="item-image"></el-image>
        </el-form-item>
        <el-form-item label="公司愿景描述" >
          <pre>{{Cdata.visionDescription}}</pre>
        </el-form-item>
        <el-form-item label="愿景图片" >
          <el-image :src="'http://'+Cdata.visionPhotoUrl" class="item-image"></el-image>
        </el-form-item>
        <el-form-item label="经营理念描述" >
          <pre>{{Cdata.manageIdeaDescription}}</pre>
        </el-form-item>
        <el-form-item label="经营理念图片" >
          <el-image :src="'http://'+Cdata.ideaPhotoUrl" class="item-image"></el-image>
        </el-form-item>
        <el-form-item label="企业文化描述" >
          <pre>{{Cdata.enterpriseCulture}}</pre>
        </el-form-item>
        <el-form-item label="企业文化图片" >
          <el-image :src="'http://'+Cdata.culturePhotoUrl" class="item-image"></el-image>
        </el-form-item>
        <el-form-item label="社会责任" >
          <pre>{{Cdata.worldDutyDescription}}</pre>
        </el-form-item>
        <el-form-item label="社会责任图片" >
          <el-image :src="'http://'+Cdata.worldDutyPhotoUrl" class="item-image"></el-image>
        </el-form-item>
        <el-form-item label="公司邮箱" >
          <pre>{{Cdata.email}}</pre>
        </el-form-item>
        <el-form-item label="创建时间" >
          <pre>{{Cdata.createTime}}</pre>
        </el-form-item>
        <el-form-item label="更新时间" >
          <pre>{{Cdata.updateTime}}</pre>
        </el-form-item>

      </el-form>
    </user-detail-base>
    <el-button @click="handleChange" style="margin-top: 15px">修改</el-button>
  </div>
</template>

<script>
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "CompanyBase",
    components: {UserDetailBase},
    data(){
      return{
        Cdata:null
      }
    },
    created() {
      this.GetData(this.PostData)
    },
    methods:{
      GetData(PageData){
        this.$axios.get('/api/companyIntro/getCompanyIntro').then(res=>{
          this.Cdata=res.data.data
        })
      },
      handleChange(){
        this.$router.push('/user/company/change')
      }
    }
  }
</script>

<style lang="less" scoped>
  .item-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    span{
      width: 64px;
      height: 16px;
      font-size: 16px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
  }
</style>